import slices from '@lootboy/lib/slices';

import slotsFilters from '~/redux/slices/slotsFilters';

import cardFilters from './cardFilters';
import location from './location';
import misc from './misc';

export default {
  ...slices,
  ...misc,
  ...cardFilters,
  ...slotsFilters,
  ...location,
};
